import { moduleSelfDiagnosisStatus } from '@/domain/enums/moduleSelfDiagnosisStatus';
import translate from '@/services/translate';

const moduleSelfDiagnosisStatusOptions = () => [
  {
    id: moduleSelfDiagnosisStatus.WITH_SELF_DIAGNOSES_ACTIVATED,
    name: translate('enums.module-self-diagnosis-status.with-self-diagnoses-activated'),
  },
  {
    id: moduleSelfDiagnosisStatus.WITHOUT_SELF_DIAGNOSES_ACTIVATED,
    name: translate('enums.module-self-diagnosis-status.without-self-diagnoses-activated'),
  },
  {
    id: moduleSelfDiagnosisStatus.UNDETERMINED,
    name: translate('enums.module-self-diagnosis-status.undetermined'),
  },
];
export default moduleSelfDiagnosisStatusOptions;
